import api from './api';
import { format } from 'date-fns';

export const getNotifications = async (filters = {}) => {
  try {
    // En producción o desarrollo sin backend, usa datos mock
    if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_USE_MOCK === 'true') {
      console.log('Using mock notifications data');
      return getMockNotifications();
    }
    
    // Construir query parameters para los filtros
    const params = {};
    
    if (filters.dateFrom) {
      params.date_from = filters.dateFrom;
    }
    
    if (filters.dateTo) {
      params.date_to = filters.dateTo;
    }
    
    const response = await api.get('/notifications', { params });
    return response.data;
  } catch (error) {
    console.error('Error en getNotifications:', error);
    // Si hay un error, devuelve datos mock en lugar de fallar
    return getMockNotifications();
  }
};

// Nueva función para obtener notificaciones por cliente
export const getNotificationsByClient = async (clientId) => {
  try {
    // En producción o desarrollo sin backend, usa datos mock
    if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_USE_MOCK === 'true') {
      console.log('Using mock client notifications data');
      return getMockClientNotifications(clientId);
    }
    
    const response = await api.get(`/clients/${clientId}/notifications`);
    return response.data;
  } catch (error) {
    console.error(`Error en getNotificationsByClient para cliente ${clientId}:`, error);
    // Si hay un error, devuelve datos mock
    return getMockClientNotifications(clientId);
  }
};

// Esta función es para uso de testing y desarrollo
export const getMockNotifications = () => {
  const today = new Date();
  
  // Generar fechas para los últimos 5 días
  const dates = Array(5).fill().map((_, index) => {
    const date = new Date(today);
    date.setDate(date.getDate() - index);
    return date;
  });
  
  return [
    {
      id: 1,
      clientName: 'María Figueroa',
      message: 'Hoy entrené bien, pero me duele un poco la rodilla izquierda.',
      date: dates[0]
    },
    {
      id: 2,
      clientName: 'Juan Ledesma',
      message: 'No pude ir al gimnasio por trabajo, retomo mañana.',
      date: dates[1]
    },
    {
      id: 3,
      clientName: 'Sofía Álvarez',
      message: 'La rutina nueva me gustó, pero no entendí bien el ejercicio 4.',
      date: dates[1]
    },
    {
      id: 4,
      clientName: 'Nicolás Varela',
      message: 'Me sentí con más energía que la semana pasada, voy mejorando.',
      date: dates[2]
    },
    {
      id: 5,
      clientName: 'Carla Domínguez',
      message: 'Hoy no pude completar los abdominales, estaba muy cansada.',
      date: dates[3]
    }
  ];
};

// Función para generar notificaciones mock para un cliente específico
export const getMockClientNotifications = (clientId) => {
  // Mensajes posibles
  const possibleMessages = [
    "Hoy entrené bien, pero me duele un poco la rodilla izquierda.",
    "No pude ir al gimnasio por trabajo, retomo mañana.",
    "La rutina nueva me gustó, pero no entendí bien el ejercicio 4.",
    "Me sentí con más energía que la semana pasada, voy mejorando.",
    "Vamos avanzando con la dieta, bajé 2 kilos esta semana.",
    "Tuve que abandonar antes la sesión por un compromiso.",
    "El entrenamiento de hoy fue excelente, me sentí muy bien.",
    "Necesito reprogramar la próxima sesión por un viaje.",
    "Tengo dolor muscular, ¿es normal después de tanto tiempo?",
    "La nueva rutina es más exigente pero me gusta el desafío."
  ];
  
  // Generar entre 5 y 10 notificaciones
  const numNotifications = 5 + Math.floor(Math.random() * 6);
  const notifications = [];
  const today = new Date();
  
  for (let i = 0; i < numNotifications; i++) {
    // Fecha aleatoria en los últimos 30 días
    const daysAgo = Math.floor(Math.random() * 30);
    const date = new Date();
    date.setDate(today.getDate() - daysAgo);
    
    // Formatear fecha
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    
    // Mensaje aleatorio
    const message = possibleMessages[Math.floor(Math.random() * possibleMessages.length)];
    
    notifications.push({
      id: i + 1,
      clientId: parseInt(clientId),
      date: formattedDate,
      message: message
    });
  }
  
  // Ordenar por fecha (más reciente primero)
  notifications.sort((a, b) => {
    const dateA = new Date(a.date.split('/').reverse().join('-'));
    const dateB = new Date(b.date.split('/').reverse().join('-'));
    return dateB - dateA;
  });
  
  return notifications;
};